import React from 'react';
import Cursor from './components/Cursor';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Cursor />
    <App />
  </React.StrictMode>
);